module.exports = __webpack_public_path__ + "static/news-6-a0438c6c2dd2386f768d6f4c6cd86093.png";